import React from 'react'
import InventoryManagerViewModel from 'admin/inventory/InventoryManagerViewModel'
import { observer } from 'mobx-react'
import PrimaryControls from 'admin/components/PrimaryControls'
import TableControls from '../TableControls'
import cx from 'classnames'
import Icon from 'components/Icon'
import styles from './InventoryViewerHeader.sass'

interface InventoryViewerHeaderProps {
  vm: InventoryManagerViewModel
}
export default observer(function InventoryViewerHeader({
  vm,
}: InventoryViewerHeaderProps) {
  return (
    <div className={styles.inventoryViewerHeader}>
      <PrimaryControls
        onChange={vm.searcher.searchText.change}
        value={vm.searcher.searchText.value}
        actions={
          <TableControls
            vm={vm}
            button={
              <div className={cx(styles.actionButton, styles.filterContainer)}>
                <Icon name="more" />
              </div>
            }
          />
        }
      />
    </div>
  )
})
